import React, { useEffect, useRef, useState } from 'react';
import { useAttributeFormBuilder, useComponentProperties } from '../../../../Hooks/Display/useComponentProperties';
import EditFormActionDialog from '../Dialogs/EditFormActionDialog';
import { useSelectedComponent } from '../../../../Hooks/Display/useComponents';
import { useSelectedPage } from '../../../../Hooks/Display/usePages';
import { Menu, MenuItem } from '@progress/kendo-react-layout';
import { Popup } from '@progress/kendo-react-popup';
import { useTranslation } from 'react-i18next';

const FormActions = ({ step }) => {
    const { t } = useTranslation([
        "display/components/form"
    ]);

    const [{ formActions, steps, selectedStepId }, dispatch] = useAttributeFormBuilder();
    const [properties, setProperty] = useComponentProperties();
    const selectedPage = useSelectedPage();
    const selectedComponent = useSelectedComponent();
    const selectedStepIndex = steps.findIndex(step => step.id === selectedStepId);
    const [showEditFormActionDialog, setShowEditFormActionDialog] = useState(false);
    const [selectedActionId, setSelectedActionId] = useState(null);
    const [showDropdownOptions, setShowDropdownOptions] = useState(false);

    const dropdownButton = useRef(null);
    const popupRef = useRef(null);

    useEffect(() => {
        const abc = formActions;
        debugger;
        window.addEventListener('click', handleOutsideClick);

        return () => {
            window.removeEventListener('click', handleOutsideClick);
        }
    }, [])

    function handleOutsideClick(e) {
        if (
            popupRef.current &&
            popupRef.current._popup &&
            !popupRef.current._popup.contains(e.target) &&
            !dropdownButton.current.contains(e.target)
        ) {
            setShowDropdownOptions(false);
        }
    }

    const getAllowedActions = () => {
        if (selectedComponent.componentType === "View") {
            if (properties.isMultiStepForm && steps.length > 1) {
                return ["Previous", "Next", "Cancel", "Submit"];
            } else {
                return ["Cancel", "Submit"];
            }
        } else {
            if (properties.isMultiStepForm) {
                if (steps.length === 1) {
                    return ["Cancel", "Submit"];
                }

                if (selectedStepIndex === 0) {
                    return ["Cancel", "Next"];
                }

                if (selectedStepIndex === steps.length - 1) {
                    return ["Submit", "Cancel", "Previous"];
                }

                return ["Cancel", "Previous", "Next"];
            } else {
                if (selectedPage.subPageType === "Edit Record") {
                    return ["Submit", "Cancel"];
                }
                return ["Submit", "Cancel", "SaveAndNew"];
            }
        }
    };


    const allowedActionType = getAllowedActions();

    const handleDialogClose = () => {
        setSelectedActionId(null);
        setShowEditFormActionDialog(false);
    };

    const handleEditButtonClick = (actionId) => {
        setShowEditFormActionDialog(true);
        setSelectedActionId(actionId);
        setShowDropdownOptions(false);
    };

    return (
        <div className={properties.isMultiStepForm ? "mt-2" : "mt-5 pt-2"}>
            {showEditFormActionDialog && (
                <EditFormActionDialog
                    handleClose={handleDialogClose}
                    actionId={selectedActionId}
                />
            )}
            <div className="d-flex justify-content-end">
                {
                    formActions.length > 0 &&
                    allowedActionType.length > 0 &&
                    <>
                        <button
                            className='btn btn-secondary'
                            ref={dropdownButton}
                            onClick={() => setShowDropdownOptions(!showDropdownOptions)}
                        >
                            <i className='k-icon k-i-more-horizontal' />
                        </button>
                        <Popup
                            anchor={dropdownButton.current}
                            show={showDropdownOptions}
                            style={{ width: '200px' }}
                            animate={false}
                            ref={popupRef}
                        >
                            {
                                formActions.length > 0 && formActions.map((action, index) => (
                                    allowedActionType.includes(action.type) && (
                                        <button
                                            key={index}
                                            className='btn text-start'
                                            onClick={() => handleEditButtonClick(action.id)}
                                        >
                                            {t("form_action_dialog.edit", { ns: "display/components/form" })} {action.name} {t("form_action_dialog.button", { ns: "display/components/form" })}
                                        </button>
                                    )
                                ))
                            }
                        </Popup>
                    </>
                }
            </div>
        </div>
    );
};

export default FormActions;